import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MetricConversions from 'libs/MetricConversions';
import Account from 'modules/Account';
import * as constants from '../constants';
const getUnitSymbol = (type, conversion)=>{
    switch(type){
        case constants.KPI_TYPES.CV:
        case constants.KPI_TYPES.GMI:
            return '%';
        case constants.KPI_TYPES.STANDARD_DEVIATION:
        case constants.KPI_TYPES.AVERAGE:
        case constants.KPI_TYPES.AVERAGE_PRE_MEAL:
        case constants.KPI_TYPES.AVERAGE_POST_MEAL:
            return conversion.unitSymbol;
        default:
            return '';
    }
};
export const useKpiUnitSymbol = (type)=>{
    const metricsUnits = useSelector(Account.selectors.metricsUnits);
    const [symbol, setSymbol] = useState('');
    useEffect(()=>{
        const metricConversions = new MetricConversions(metricsUnits);
        const conversion = metricConversions.bloodGlucoseConcentration;
        const kpiSymbol = getUnitSymbol(type, conversion);
        setSymbol(kpiSymbol);
    }, [
        type
    ]);
    return symbol;
};
